/**
 * External destinations used from more than one place (TEC-3821). The NGO area is not here:
 * `useNgoAreaUrl` derives it from the host, so a link followed from `snd` stays in `snd`.
 */

/** What a donor can answer for themselves: donation status and tax certificate. */
export const DONOR_APP_URL = 'https://app.worldcoo.com';

export const JOBS_URL = 'https://www.linkedin.com/company/worldcoo/jobs/';

/**
 * The Google Form the NGO team reads applications from; NOT the NGO area's own onboarding, which
 * `useNgoAreaUrl` serves (the FAQ's sign-up answer is the last CTA still pointing there).
 */
export const NGO_APPLICATION_FORM_URL =
	'https://docs.google.com/forms/d/e/1FAIpQLSc3pM2f0XBePXX-c60VjkWxWqIAghe3f2R-a1hr3ldwkuI_1A/viewform';
